module.exports = {
  LOCAL: {
    API_BASE_URL: "http://localhost:4000",
    GTM_ENABLED: false,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "http://localhost:3001/authentication/sign-in",
    CUSTOMER_LINKS: {
      SIGN_IN: "http://localhost:3001/authentication/sign-in",
      FORGOT_PASSWORD: "http://localhost:3001/authentication/forgot-password",
    },
    GTM_ID: "GTM-N4G9BHVK",
    TURNSTILE_SITE_KEY: "0x4AAAAAADG4D2dHl0nNFaQe",
    WIDGET_LOADER_URL: "https://widget-staging.cateringrewards.com/loader.js",
    WIDGET_PARTNER_KEY: "wp_5c7dbebfa8f8413c2e4ac83f6a2d2df2",
  },
  DEV: {
    API_BASE_URL: "https://api-dev.cateringrewards.com",
    BUGSNAG_API_KEY: "098010f2042562d2229f08cd86ff64f3",
    BUGSNAG_RELEASE_STAGE: "development",
    GTM_ENABLED: false,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://user-dev.cateringrewards.com/authentication/sign-in",
    CUSTOMER_LINKS: {
      SIGN_IN: "https://user-dev.cateringrewards.com/authentication/sign-in",
      FORGOT_PASSWORD: "https://user-dev.cateringrewards.com/authentication/forgot-password",
    },
    GTM_ID: "GTM-N4G9BHVK",
    TURNSTILE_SITE_KEY: "0x4AAAAAADG4D2dHl0nNFaQe",
  },
  STAGING: {
    API_BASE_URL: "https://api-staging.cateringrewards.com",
    BUGSNAG_API_KEY: "098010f2042562d2229f08cd86ff64f3",
    BUGSNAG_RELEASE_STAGE: "staging",
    GTM_ENABLED: false,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://user-staging.cateringrewards.com/authentication/sign-in",
    CUSTOMER_LINKS: {
      SIGN_IN: "https://user-staging.cateringrewards.com/authentication/sign-in",
      FORGOT_PASSWORD: "https://user-staging.cateringrewards.com/authentication/forgot-password",
    },
    GTM_ID: "GTM-5DF8767V",
    TURNSTILE_SITE_KEY: "0x4AAAAAADG4D2dHl0nNFaQe",
    WIDGET_LOADER_URL: "https://widget-staging.cateringrewards.com/loader.js",
    WIDGET_PARTNER_KEY: "wp_5c7dbebfa8f8413c2e4ac83f6a2d2df2",
  },
  PRE_PROD: {
    API_BASE_URL: "https://api-pre-prod.cateringrewards.com",
    BUGSNAG_API_KEY: "098010f2042562d2229f08cd86ff64f3",
    BUGSNAG_RELEASE_STAGE: "pre-production",
    GTM_ENABLED: false,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://user-pre-prod.cateringrewards.com/authentication/sign-in",
    CUSTOMER_LINKS: {
      SIGN_IN: "https://user-pre-prod.cateringrewards.com/authentication/sign-in",
      FORGOT_PASSWORD: "https://user-pre-prod.cateringrewards.com/authentication/forgot-password",
    },
    TURNSTILE_SITE_KEY: "0x4AAAAAADG4D2dHl0nNFaQe",
  },
  PROD: {
    API_BASE_URL: "https://api.cateringrewards.com",
    BUGSNAG_API_KEY: "098010f2042562d2229f08cd86ff64f3",
    BUGSNAG_RELEASE_STAGE: "production",
    GTM_ENABLED: true,
    GOOGLE_CLIENT_ID: "491822101832-o1lnjl8e1hvd7k3lbsnaf285hdh1f5k8.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://my.cateringrewards.com/authentication/sign-in",
    CUSTOMER_LINKS: {
      SIGN_IN: "https://my.cateringrewards.com/authentication/sign-in",
      FORGOT_PASSWORD: "https://my.cateringrewards.com/authentication/forgot-password",
    },
    GTM_ID: "GTM-M5B3S9M3",
    TURNSTILE_SITE_KEY: "0x4AAAAAADG3toFUnK8Dfds_", 
  },
};
